// Re-exports for backward compatibility during migration.
// Views should gradually import from 'store' or 'store/slices/*' directly.
export { rootReducer, type RootState } from './rootReducer';

import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { RootState } from './rootReducer';

export const useStateSelector: TypedUseSelectorHook<RootState> = useSelector;
